export default __webpack_public_path__ + "static/media/bimma-williams-640.1ba418fa.jpg";